import {
  DELETE_INSURED_INFO,
  EDIT_INSURED_INFO,
  FETCH_INSURED,
  FETCH_LIFE_SETTLEMENT_CASE,
  LOADING,
  SELECT_INSURED,
} from "actions/types";
import * as notifications from "notifications.js";
import advisorhq from "apis/advisorhq";
import { ValidationError } from "exceptions.js";
import { activeCaseIdSelector, insuredListSelector } from "reducers";

export const selectInsured = id => {
  return { type: SELECT_INSURED, payload: id };
};

export const fetchInsured = caseId => async dispatch => {
  const endpoint = `/life_settlement/api/insured_information/`;
  const response = await advisorhq.get(endpoint, { params: { case: caseId } });
  dispatch({ type: FETCH_INSURED, payload: response.data });
  dispatch({ type: LOADING, payload: { insured: false } });
};

export const editInsuredInfo = (insuredInfoId, newValues) => async dispatch => {
  const endpoint = `/life_settlement/api/insured_information/${insuredInfoId}/`;
  const response = await advisorhq.patch(endpoint, newValues);
  dispatch({ type: EDIT_INSURED_INFO, payload: response.data });
};

export const deleteInsuredInfo = insuredInfoId => async (dispatch, getState) => {
  const endpoint = `/life_settlement/api/insured_information/${insuredInfoId}/`;
  await advisorhq.delete(endpoint);
  dispatch(selectInsured(null)); // reset selected section
  dispatch({ type: DELETE_INSURED_INFO, payload: insuredInfoId });
  notifications.success("Insured information deleted successfully");

  // Re-fetch case
  const activeCaseId = activeCaseIdSelector(getState());
  const response = await advisorhq.get(`/life_settlement/api/cases/v2/${activeCaseId}/`);
  dispatch({ type: FETCH_LIFE_SETTLEMENT_CASE, payload: response.data });
};
